module.exports = __webpack_public_path__ + "img/p2.6569a2ec.png";